<template>
  <div class='h-100 overflow-hidden'>
    <BlockUI v-if="isLoading" :message="msg">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    </BlockUI>

    <vue-confirm-dialog></vue-confirm-dialog>

    <v-app-bar dense :elevation="1">

      <div class="
          container-fluid
          d-flex
          align-items-center
          justify-content-between
          flex-wrap flex-sm-nowrap
        ">
        <div class="d-flex align-items-center flex-wrap mr-2">
          <h5 class="font-weight-bolder text-dark mb-0 mr-1 MySubHeaderTitle">
            Yard View
          </h5>

          <div class="
              subheader-separator subheader-separator-ver
              mt-2
              mb-2
              ml-4
              mr-4
              bg-gray-100
            "></div>

          <span class="text-muted mb-0 mr-1">
            {{ FilterTerminalText }}
          </span>


        </div>

        <div class="d-flex gap-1">
          <!--begin::Toolbar-->


          <!-- Start Filter -->
          <app-button @click="modalShowFilter = true">
            <i class="fa fa-filter icon-sm"></i>
            FILTER
          </app-button>
          <!-- End Filter -->



          <app-button @click="RefreshHandler">
            <i class="fas fa-sync-alt"></i>
            REFRESH
          </app-button>
          <!--             
            <button type="button" @click="RefreshHandler" class="
              btn btn-outline-primary
              font-weight-bold
              btn-sm
              mr-2
              Mybtn1-primary
              Mybtn-size1
            ">
              <i class="fas fa-sync-alt"></i>
              REFRESH
            </button> -->




        </div>

        <!--end::Toolbar-->
      </div>
    </v-app-bar>

    <!-- Start Modal Filter -->
    <b-modal id="modalFilter" ref="modalFilter" title v-model="modalShowFilter" size="lg" hide-footer centered
      content-class="shadow" header-class=" pb-8 ribbon ribbon-clip ribbon-left" body-class="pt-3">
      <template #modal-title>
        <div class="ribbon-target" style="top: 12px">
          <span class="ribbon-inner bg-warning"></span>
          <span class="font-weight-bolder font-size-sm">Filter</span>
        </div>
      </template>
      <b-form-group label="Port" label-for="treeTerminal" @submit.stop.prevent>
        <treeselect :options="terminals" :value='terminal' @select="terminalSelectHandler" :multiple="false"
          placeholder="Select your item(s)...">
        </treeselect>
      </b-form-group>

    </b-modal>
    <!-- End Modal Filter -->


    <div style="height: 95%;width: 100%; overflow-y: hidden; padding: 0">
      <YardView :styleMap='styleMap' :terminals='terminals' :terminalId='terminalId' :terminal='terminal'
        :key='this.isPageRefreshing' />
    </div>

    <!-- Start Modal details container info-->

     <b-modal  title v-model="modalShowContainerInfos" size="sm"
      hide-footer centered content-class="shadow" header-class=" pb-8 ribbon ribbon-clip ribbon-left" body-class="pt-3">
      <template #modal-title>
        <div class="ribbon-target" style="top: 10px">
          <span class="ribbon-inner bg-warning"></span>
          <span class="font-weight-bolder font-size-lg">container info</span>
        </div>
      </template>

      <p class="font-weight-bolder font-size-sm">Container No:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentContainerInfo.ContainerNo}}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm">Container Size (ft):
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentContainerInfo.LengthFt }}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm">Container Type:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentContainerInfo.Type }}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm">CycleType:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">
          {{ currentContainerInfo.ContainerCycleType }}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm">LoadStatus:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">
          {{ currentContainerInfo.LoadStatus == "E" ? "Empty" : "Full" }}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm">ArrivalDate:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">
          {{ currentContainerInfo.LiftOffDate }}
        </span>
      </p>
      <app-button @click="ShowDetailContainer">
        <i class="fa fa-info-circle icon-sm"></i>
        Show Detail
      </app-button>

    </b-modal>

    <!-- End Modal details container info -->

    <!-- Start Modal details container info-->

     <b-modal  title v-model="modalShowBlockInfos" size="sm"
      hide-footer centered content-class="shadow" header-class=" pb-8 ribbon ribbon-clip ribbon-left" body-class="pt-3">
      <template #modal-title>
        <div class="ribbon-target" style="top: 10px">
          <span class="ribbon-inner bg-warning"></span>
          <span class="font-weight-bolder font-size-lg">Block info</span>
        </div>
      </template>
      <p class="font-weight-bolder font-size-sm">Code:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentBlockInfo.code}}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm">Total Capacity:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentBlockInfo.totalCapacity}}
        </span>
      </p>
      <p class="font-weight-bolder font-size-sm"> Free space:
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentBlockInfo.freeSpace }}
        </span>
      </p>     
      <p class="font-weight-bolder font-size-sm">Free slot (20ft):
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentBlockInfo.oneTEUFreeSlot }}
        </span>
      </p> 
      <p class="font-weight-bolder font-size-sm">Free slot (40ft):
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentBlockInfo.twoTEUFreeSlot }}
        </span>
      </p>      
    </b-modal>

    <!-- End Modal details container info -->


    <!-- Start Modal SOF -->
    <b-modal id="modalSOFSVG1" ref="modalsofsvg1" title v-model="modalShowSOFSVG" size="xl" hide-footer centered
      content-class="shadow" header-class=" pb-8 ribbon ribbon-clip ribbon-left" body-class="pt-3">
      <template #modal-title>
        <div v-if="currentSvgData" class="ribbon-target" style="top: 12px">
          <span class="ribbon-inner bg-warning" />
          <span class="font-weight-bolder font-size-sm pr-2">{{
            currentSvgData.voyage.voyageId
          }}</span>
          <span class="font-weight-bolder font-size-sm">{{
            currentSvgData.vessel.name
          }}</span>
          <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">{{ currentSvgData.voyage.voyageNoIn
            }}/{{
              currentSvgData.voyage.voyageNoOut
            }}</span>
        </div>
      </template>

      <!-- :ScheduleItem="currentSvgData" -->
      <VesselTimeLineSVG :isReadOnly="true" :isConcept="false" :VoyageId="currentSvgDataVoyageId" :ConceptId="null"
        v-show="modalShowSOFSVG" :mUpdateScheduleByVoyageId="null" :mGetScheduleByVoyageId="GetScheduleByVoyageId"
        :mGetConceptItemByVoyageIdConceptId="null" :mUpdateScheduleBerthSideByVoyageId="null"
        :mDeleteScheduleByVoyageId="null"></VesselTimeLineSVG>
    </b-modal>
    <!-- End Modal SOF -->
  </div>
</template>

<script>
import Vue from "vue"
import { mapGetters, mapActions } from "vuex"
import { GETSETTINGLIST } from "@/core/services/store/setting.module";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import VesselTimeLineSVG from "../berthplanning/VesselTimeLine_SVG.vue"
import YardView from "@/components/YardView.vue"
import { NumberFormat } from "@/mixins.ts"
import {
  GETBerthInit,
  GetBerthChartScheduleByVoyageId,
} from "@/core/services/store/berthplanning.module"
import { GETSETTIONID } from "@/core/services/store/legacy-bridge.module"
import AppButton from "@/components/AppButton.vue"
import moment from "moment";

export default {
  inject: ["showErrors", "showSuccess", "isStandalone"],
  mixins: [NumberFormat],
  components: {
    VesselTimeLineSVG,
    YardView,
    AppButton,
  },

  data: function () {
    return {
      styleMap: "height:100%;overflow-y: hidden",
      msg: "Please wait ...",
      loading: false,
      apiurl: `${Vue.axios.defaults.baseURL}/tos/BerthMonitoring/getterminalmonitoring`,
      terminals: [],
      terminal: null,
      terminalId: null,
      src: null,
      standalone: this.isStandalone,
      modalShowFilter: false,
      FilterTerminalText: "",

      currentSvgData: null,
      currentSvgDataVoyageId: 0,
      modalShowSOFSVG: false,

      qualites: [
        {
          value: "high",
          text: "High Quality",
          style: "font-size:100px;",
        },
        {
          value: "medium",
          text: "Medium Quality",
        },
        { value: "low", text: "Low Quality" },
      ],
      // quality: "medium",
      quality: "high",
      customAttr: function () {
        return {
          style: "font-size:40px",
        }
      },
      modalShowContainerInfos: false,
      modalShowBlockInfos:false,
      currentContainerInfo: {},
      currentBlockInfo: {}

    }
  },
  computed: {
    ...mapGetters([
      "getBerthChartInit",
      "getBerthChart",
      "getPlanbyStartPosition",
      "getUpdateBerthChart",
      "getBerthChartErrors",
      "getBerthChartMessages",
      "getberthchartschedulebyvoyageid",
      "getLegacyErrors",
      "getLegacyMessages",
    ]),
    ...mapActions([
      "toggleIsPageRefreshing"
    ]),
    yardViewUrl() {
      // Fetch the config.json file


      this.config = process.env.VUE_APP_BASE_YARDVIEW || data.VUE_APP_BASE_YARDVIEW



    }, //  "http://localhost:9000",
    isLoading() {
      return this.$store.state.berthMonitoring.isLoading
    },
    isPageRefreshing() {
      return this.$store.state.berthMonitoring.isPageRefreshing
    }

  },
  mounted() {
    // Set the user payload
    const userPayload = this.$route.query.UserPayload


    Vue.prototype.$userPayload = userPayload


    this.loading = true
    // this.yardViewUrl = process.env.VUE_APP_BASE_YARDVIEW;
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Yard View" }])
    this.getInit()
    // this.getSessionId();
  },
  watch: {
    terminal: function (val) {
      this.terminalId = Array.isArray(val) ? val[0] : val;
    },
    terminalId: function (val) {
      if (Array.isArray(val)) this.terminalId = val[0]
      else this.terminalId = val
    },
    quality: function (val) {
      this.quality = val
      // this.src = this.yardViewUrl + this.buildhref(this.dockid);
    },
  },
  methods: {
    ShowDetailContainer() {
      var postMessageParams = {
        ContaonerID: this.currentContainerInfo.Id,
        ContainerNo: this.currentContainerInfo.ContainerNo,
        TerminalId: this.terminalId,
        action: "detailContainer"
      }

      window.parent.postMessage(postMessageParams, "*");
    },
    terminalSelectHandler(node) {
      this.terminal = node.id
      this.terminalId = node.id
      this.modalShowFilter = false
      this.getTerminalName()
    },

    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children
      }
    },
    getSessionId() {
      // this.SessionId="184be185-3edc-40d1-bf3d-e8f4ee869604";
      this.$store.dispatch(GETSETTIONID).then((res) => {
        this.SessionId = res.data
        const errors = this.getLegacyErrors
        this.showErrors(errors)
      })
      return this.SessionId
    },
    buildhref(terminalId) {
      const apiurl = encodeURI(this.apiurl)
      // this.SessionId = this.getSessionId();
      return `?quality=${this.quality
        }&terminalid=${terminalId}&sessionId=${this.SessionId}&apiurl=${apiurl}&pageurl=${window.location.href
        }`
    },
    RefreshHandler() {
      this.getTerminalName()
      this.$store.dispatch('toggleIsPageRefreshing')

      // this.toggleIsPageRefreshing()
    },
    getTerminalName() {
      const foundTerminal = this.terminals.find((i) => i.id == this.terminalId)
      const newTerminalId = foundTerminal.id
      this.FilterTerminalText = foundTerminal.label
      if (process.env.NODE_ENV === 'development') {
      }
      // this.terminalId = newTerminalId
      this.terminal = newTerminalId
    },
    Refresh_Click() {
      this.getTerminalName()

      // this.loading = true;
      this.modalShowFilter = false
      this.src = ""
      // try {
      //   this.SessionId = this.getSessionId();
      // } catch (error) {
      //   console.error('error setting session id');
      // }
    },
    async getInit() {
      try {
        //await this.$store.dispatch(GETSETTINGLIST)    
        await this.$store.dispatch(GETBerthInit)
        const errors = this.getBerthChartErrors

        if (errors.length > 0) {
          return this.showErrors(errors)
        }

        const model = this.getBerthChartInit
        if (!model.ports.length) {
          return this.showWarning("عدم دریافت اطلاعات")
        }


        this.terminals = model.ports
        this.terminal = [model.terminalId]
        this.terminalId = model.terminalId
        this.Refresh_Click()

      } catch (error) {
        console.error("Error initializing:", error)
        this.showErrors(["Error initializing data"])
      }
    },


    async GetScheduleByVoyageId(voyageId, callback) {
      try {
        const state = {
          VoyageId: Number(voyageId),
          TerminalId: Number(this.terminalId)
        };

        await this.$store.dispatch(GetBerthChartScheduleByVoyageId, state);

        const errors = this.getBerthChartErrors;
        if (errors && errors.length > 0) {
          this.showErrors(errors);
          return callback(null);
        }

        let itemSchedule = this.getberthchartschedulebyvoyageid;
        itemSchedule = this.Create_BerthPlanView_ScheduleSVG(itemSchedule);
        this.currentSvgData = itemSchedule;
        callback(itemSchedule);

      } catch (error) {
        console.error("Error in GetScheduleByVoyageId:", error);
        this.showErrors(["Unexpected error occurred"]);
        callback(null);
      }
    },


    Create_BerthPlanView_ScheduleSVG(itemSchedule) {
      let Operation = '';

      const {
        voyageDetail: {
          d20, d40, d45, l20, l40, l45, r20, r40, r45, tonnage
        },
        vessel: { vesselType }
      } = itemSchedule;

      if (vesselType === 'ContainerShip') {
        const totalMove = Number(d20) + Number(d40) + Number(d45) +
          Number(l20) + Number(l40) + Number(l45) +
          Number(r20) + Number(r40) + Number(r45);

        Operation = `total move(s) ${this.NumberWithCommas(totalMove)}`;
      } else if (tonnage > 0) {
        Operation = `${this.NumberWithCommas(tonnage)} tons`;
      }

      const {
        id, rowVersion, conceptId, isConcept,
        isPlan, isAllowSave, moveLocked, moveTimeLocked,
        isOutofRange, startDateOriginal, startBollardId,
        endBollardId, startBollardName, endBollardName,
        startDate, endDate, berthName, description,
        lineServiceName, ...rest
      } = itemSchedule;

      const Schedule = {
        id,
        rowVersion,
        ConceptId: conceptId,
        isConcept,
        IsPlan: isPlan,
        IsAllowSave: isAllowSave,
        moveLocked,
        moveTimeLocked,
        isOutofRange: isOutofRange ?? false,
        startDateOriginal: startDateOriginal ?? null,
        startBollardId: startBollardId === '0' ? '' : startBollardId,
        endBollardId: endBollardId === '0' ? '' : endBollardId,
        StartBollardName: startBollardName,
        endBollardName,
        startDate: new Date(startDate),
        endDate: new Date(endDate),
        berthName,
        description,
        lineServiceName,
        voyage: {
          voyageId: itemSchedule.voyageId,
          voyageNoIn: itemSchedule.voyageNoIn,
          voyageNoOut: itemSchedule.voyageNoOut,
          VoyageStatusId: itemSchedule.voyageStatusId,
          VoyageStatus: itemSchedule.voyageStatus,
          side: itemSchedule.side,
          marginLeft: itemSchedule.marginLeft,
          marginRight: itemSchedule.marginRight,
          shippingLine: itemSchedule.lineName,
          agentName: itemSchedule.agentName,
          ETA: itemSchedule.eta,
          anchorage: itemSchedule.anchorage,
          berthDate: itemSchedule.berthDate,
          startLoadOperation: itemSchedule.startLoadOperation,
          endLoadOperation: itemSchedule.endLoadOperation,
          startDischargeOperation: itemSchedule.startDischargeOperation,
          endDischargeOperation: itemSchedule.endDischargeOperation,
          unberthDate: itemSchedule.unberthDate,
          fullaway: itemSchedule.fullaway,
          ETD: itemSchedule.etd,
          EPT: itemSchedule.ept,
          PortTime: itemSchedule.portTime,
          loadOperationTime: itemSchedule.loadOperationTime,
          dischargeOperationTime: itemSchedule.dischargeOperationTime,
          berthTime: itemSchedule.berthTime,
        },
        vessel: {
          ...rest.vessel,
        },
        voyageDetails: {
          operations: Operation,
          D20: Number(d20),
          D40: Number(d40),
          D45: Number(d45),
          L20: Number(l20),
          L40: Number(l40),
          L45: Number(l45),
          R20: Number(r20),
          R40: Number(r40),
          R45: Number(r45),
        },
      };

      return Schedule;
    },
  },
  beforeRouteUpdate: function (to) {
    if (to.query.blockInfo != undefined && to.query.blockInfo != "undefined") {
      this.currentBlockInfo = null
      this.modalShowBlockInfos = true
      this.currentBlockInfo = JSON.parse(decodeURIComponent(to.query.blockInfo))
    } 
     if (to.query.containerinfo != undefined && to.query.containerinfo != "undefined") {
      this.currentContainerInfo = null
      this.modalShowContainerInfos = true
      this.currentContainerInfo = JSON.parse(to.query.containerinfo)
      this.currentContainerInfo.LiftOffDate = moment(this.currentContainerInfo.LiftOffDate).format("YYYY-MM-DD HH:mm:ss")
    } 
    if (to.query.vechileid != undefined && to.query.vechileid != "undefined") {
          this.currentSvgDataVoyageId = Number(to.query.vechileid)
          this.modalShowSOFSVG = true
       }
    
    if (to.query.complete) {
      this.loading = false
    }
  }
}
</script>
